<template>
  <div v-if="isSafari || !isInstall.value">
    <div
      class="add-to-home j-add-to-home"
      @click="isSafari ? showSafariTip() : installPwa()"
    >
      <em class="ico iconfont icon-tag"></em>
      <span class="text">{{ letter.voucherAddHome }}</span>
    </div>
    <safari-pwa-guide-popup
      v-if="isGuide"
      @closePopup="hideSafariTip"
    ></safari-pwa-guide-popup>
  </div>
</template>

<script>
import Vue from 'vue';
import { commonEmitUpload } from '../../plugins/AnalyzePoint/index';
import { isSafari } from '@utiles/officialStore/device';
import SafariPwaGuidePopup from '@components/officialWebStore/SafariPwaGuidePopup.vue';
import globalConfig from '@utiles/officialStore/globalConfig';
import {
  popupType,
  showPopup,
  clickButton
} from '@plugins/biPoint/_configWebstoreV2';
export default {
  components: { SafariPwaGuidePopup },
  name: 'PwaInstall',
  data() {
    return {
      isInstall: null,
      isSafari: isSafari(),
      isGuide: false
    };
  },
  computed: {
    letter() {
      return this.$store.state.letter;
    }
  },
  created() {
    // 生成响应式对象，同步window的isInstall和组件data里面的isInstall，随意更改组件或是window的isInstall都会同步到另一个上
    const pwaState = Vue.observable(window.isInstall);
    this.isInstall = pwaState;
    window.isInstall = pwaState;
  },
  mounted() {
    // app安装了
    window.addEventListener('appinstalled', () => {
      this.setIsInstall();
      // 回收 deferredPrompt 变量
      window.deferredPrompt = null;
      // pwa成功安装
      commonEmitUpload('success-install-pwa', {
        event: 'success-install-pwa',
        newPage: false,
        type: 'change'
      });
    });
  },
  methods: {
    setIsInstall() {
      this.isInstall.value = true;
    },
    showSafariTip() {
      this.isGuide = true;
      clickButton({
        btnName: 'add_to_screen',
        locationKey: this.$route.meta.pageName
      });
      showPopup(popupType.safariAddToHomePopup);
    },
    hideSafariTip() {
      this.isGuide = false;
    },
    updateUrlWithParams(currentUrl, newParams) {
      // 解析当前 URL
      const url = new URL(currentUrl);
      // 遍历并更新/添加新的查询参数
      Object.keys(newParams).forEach(key => {
        url.searchParams.set(key, newParams[key]);
      });
      // 返回更新后的 URL 字符串
      return url.toString();
    },
    installPwa() {
      // 用户点击页面上的安装按钮
      commonEmitUpload('click-install-pwa-btn', {
        event: 'click-install-pwa-btn',
        newPage: false,
        type: 'click'
      });
      clickButton({
        btnName: 'add_to_screen',
        locationKey: this.$route.meta.pageName
      });
      if (!window.deferredPrompt) return;
      window.deferredPrompt.prompt();
      window.deferredPrompt.userChoice.then(result => {
        if (result.outcome == 'dismissed') {
          // 用户点击页面上的安装按钮
          commonEmitUpload('cancel-install-pwa', {
            event: 'cancel-install-pwa',
            newPage: false,
            type: 'click'
          });
        } else if (result.outcome == 'accepted') {
          window.setIsInstall();
          this.setIsInstall();
          window.deferredPrompt = null;

          // 用户点击页面上的安装按钮
          commonEmitUpload('accept-install-pwa', {
            event: 'accept-install-pwa',
            newPage: false,
            type: 'click'
          });
          // 2025-01-08 同manifest动态生成的参数链接一致
          const curCid = globalConfig.getHrefParam('cid');
          const curScid = globalConfig.getHrefParam('scid');
          try {
            let link = this.updateUrlWithParams(window.location.href, {
              cid: curCid,
              scid: curScid,
              mode: 'pwa'
            });
            window.location.href = window.globalGetGotoLink({ link });
          } catch (e) {
            console.error(e);
          }
        }
        // 接受了安装才会返回平台，没有接受不会返回平台
        // console.log('Install platform: ' + result.platform);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialWebStore/_dimen.scss';

.add-to-home {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
  background: $btnBg;
  height: 45px;
  box-sizing: border-box;
  border-radius: 30px;
  cursor: pointer;
  margin-left: 20px;
  font-size: 22px;
  color: #fff;
  .ico {
    display: block;
    margin-right: 10px;
    color: #fff;
    font-size: 22px;
  }
}

@media screen and (orientation: landscape) {
  .add-to-home {
    font-size: 16px;
  }
}
</style>
